"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisconnectDomainWarning = exports.DowngradePlanWarning = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _PanTool = _interopRequireDefault(require("@material-ui/icons/PanTool"));

var _Button = _interopRequireDefault(require("../Button"));

var _Checkbox = _interopRequireDefault(require("../Checkbox"));

var DowngradePlanWarning = function DowngradePlanWarning(_ref) {
  var domain = _ref.domain,
      _ref$removedFeatures = _ref.removedFeatures,
      removedFeatures = _ref$removedFeatures === void 0 ? [] : _ref$removedFeatures,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["domain", "removedFeatures"]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var items = removedFeatures.filter(function (feature) {
    return feature === 'customDomain' ? !!domain : true;
  }).map(function (feature) {
    if (feature === 'customDomain' && domain) {
      return /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        i18nKey: "criticalWarning.items.".concat(feature),
        values: {
          domain: domain
        }
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "text-primary",
        href: t('supportSite'),
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Learn more"));
    }

    return t("criticalWarning.items.".concat(feature));
  }).filter(Boolean);
  return /*#__PURE__*/_react["default"].createElement(CriticalWarning, (0, _extends2["default"])({
    subtitle: t('criticalWarning.subtitle.premium'),
    confirm: t('criticalWarning.premium.downgrade')
  }, rest), /*#__PURE__*/_react["default"].createElement("ol", {
    className: "list-decimal list-inside leading-loose"
  }, items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i
    }, item);
  })));
};

exports.DowngradePlanWarning = DowngradePlanWarning;

var DisconnectDomainWarning = function DisconnectDomainWarning(_ref2) {
  var domain = _ref2.domain,
      removedFeatures = _ref2.removedFeatures,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["domain", "removedFeatures"]);

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var items = removedFeatures.filter(function (feature) {
    return feature === 'customDomain' ? !!domain : true;
  }).map(function (feature) {
    if (feature === 'customDomain') {
      return /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        i18nKey: "criticalWarning.items.".concat(feature),
        values: {
          domain: domain
        }
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "text-primary",
        href: t('supportSite'),
        target: "_blank",
        rel: "noopener noreferrer"
      }, "Learn more"));
    }

    return t("criticalWarning.items.".concat(feature));
  }).filter(Boolean);
  return /*#__PURE__*/_react["default"].createElement(CriticalWarning, (0, _extends2["default"])({
    subtitle: t('criticalWarning.subtitle.domain'),
    confirm: t('criticalWarning.domain.disconnect')
  }, rest), /*#__PURE__*/_react["default"].createElement("ol", {
    className: "list-decimal list-inside leading-loose"
  }, items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: i
    }, item);
  })));
};

exports.DisconnectDomainWarning = DisconnectDomainWarning;

var CriticalWarning = function CriticalWarning(_ref3) {
  var isOpen = _ref3.isOpen,
      toggle = _ref3.toggle,
      subtitle = _ref3.subtitle,
      confirm = _ref3.confirm,
      children = _ref3.children,
      onCancel = _ref3.onCancel,
      onConfirm = _ref3.onConfirm;

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      accept = _useState2[0],
      setAccept = _useState2[1]; // Reset accept when modal is toggled


  (0, _react.useEffect)(function () {
    setAccept(false);
  }, [isOpen]);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    open: isOpen,
    onClose: function onClose() {
      return isOpen && toggle();
    },
    maxWidth: "md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 bg-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-4 border-red rounded-full h-16 w-16 flex items-center justify-center text-red mb-3"
  }, /*#__PURE__*/_react["default"].createElement(_PanTool["default"], null)), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-4xl font-bold"
  }, t('criticalWarning.title')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light"
  }, subtitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-secondary dark:bg-app text-light p-5 my-5"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-5 -ml-3"
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    checked: accept,
    id: "accept",
    name: "accept",
    onChange: function onChange(value) {
      return setAccept(value);
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "accept",
    className: "text-light cursor-pointer"
  }, t('criticalWarning.confirmation'))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onCancel,
    color: "secondary",
    className: "w-32 mr-5"
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    disabled: !accept,
    onClick: onConfirm,
    color: "warning",
    className: "w-64"
  }, confirm))));
};
//# sourceMappingURL=index.js.map